// eslint-disable-next-line
import React from "react";
import { Link } from "react-router-dom";


const BusinessLink = ({ to = "", children, ...props }) => {
  // let { slugname } = useParams();
  return (
    // <Link {...props} to={`/${slugname}${to}`}>
    <Link {...props} to={`${to}`}>
      {children}
    </Link >
  )
}

export default BusinessLink